var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("img", {
        ref: "floorplanImage",
        staticClass: "enlarge-floorplan-image",
        attrs: { src: _vm.floorplan },
        on: {
          load: function ($event) {
            return _vm.onResize()
          },
        },
      }),
      _vm._v(" "),
      _c("floorplan-dots", {
        staticClass: "dots-init-positioning",
        attrs: {
          ratio: _vm.positionRatio,
          "ratio-rfe": _vm.positionRatioRfe,
          "x-offset": _vm.xOffset,
          "y-offset": _vm.yOffset,
          scale: _vm.pointScale,
        },
        on: { selectedPanorama: _vm.onSelectedPanorama },
      }),
      _vm._v(" "),
      _c("floorplan-range", {
        staticClass: "dots-init-positioning",
        attrs: {
          ratio: _vm.positionRatio,
          "ratio-rfe": _vm.positionRatioRfe,
          "x-offset": _vm.xOffset,
          "y-offset": _vm.yOffset,
          scale: _vm.pointScale,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }